module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"dashboardTeaser":{"teasertext":"In Ihrem persönlichen Bereich <strong>Meine DA Direkt</strong> finden Sie alle Verträge auf einen Blick – transparent und detailliert. Ihre Policen, Beitragsrechnungen und Mitteilungen sind damit für Sie griffbereit."}}}')
  delete Component.options._Ctor
}
